import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'

Vue.use(VueRouter)

const routes = [
  {
    path:'/',
    redirect:'/home'
  },
  {
    path: '/home',
    name: 'home',
    component: Home
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/cards',
    name: 'cards',
    component: () => import(/* webpackChunkName: "Campaign" */ '../views/Cards.vue')
  },
  {
    path: '/rank',
    name: 'rank',
    component:() => import(/* webpackChunkName: "Rank" */ '../views/Rank.vue')
  },
  {
    path: '/profile',
    name: 'profile',
    component:() => import(/* webpackChunkName: "Profile" */ '../views/Profile.vue')
  },
  {
    path: '/dispatch',
    name: 'dispatch',
    component:() => import(/* webpackChunkName: "Dispatch" */ '../views/Dispatch.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
